import { setTheme } from '../index.mjs';

function ThemeServerInit({ theme }) {
  setTheme(theme);
  return null;
}

export { ThemeServerInit };
//# sourceMappingURL=server.mjs.map
